import { h } from 'preact';

function CopyText (props) {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      fill="#B31E2F"
      {...props}
    >
      <path
        d="M1.8 0A1.8 1.8 0 000 1.8v12.6h1.8V1.8h12.6V0H1.8zm3.6 3.6a1.8 1.8 0 00-1.8 1.8v10.8A1.8 1.8 0 005.4 18h10.8a1.8 1.8 0 001.8-1.8V5.4a1.8 1.8 0 00-1.8-1.8H5.4zm0 1.8h10.8v10.8H5.4V5.4z"
        fillRule="nonzero"
      />
    </svg>
  );
}

export default CopyText;
